import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'back-page',
  templateUrl: './back.component.html',
  styleUrls: ['./back.component.scss']
})
export class BackComponent {
    public constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/back/back.component.ts